function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M13 25C6.38266 25 1 19.6173 1 13C1 6.38266 6.38266 1 13 1C19.6173 1 25 6.38266 25 13C25 19.6173 19.6173 25 13 25ZM13 2.33333C7.11866 2.33333 2.33333 7.11866 2.33333 13C2.33333 18.8813 7.11866 23.6666 13 23.6666C18.8813 23.6666 23.6666 18.8813 23.6666 13C23.6666 7.11866 18.8813 2.33333 13 2.33333Z",
  fill: "#9E9E9E",
  stroke: "#9E9E9E",
  strokeWidth: 0.3
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M12.9999 24.9996C12.8279 24.9996 12.6572 24.933 12.5265 24.8036C6.07319 18.2943 6.07319 7.70632 12.5265 1.197C12.7865 0.939664 13.2092 0.932997 13.4705 1.193C13.7305 1.453 13.7332 1.87566 13.4745 2.137C7.53319 8.12632 7.53319 17.8743 13.4745 23.8636C13.7332 24.125 13.7305 24.5476 13.4705 24.8076C13.3399 24.9356 13.1692 24.9996 12.9999 24.9996Z",
  fill: "#9E9E9E",
  stroke: "#9E9E9E",
  strokeWidth: 0.3
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M12.9999 25C12.8306 25 12.6599 24.936 12.5293 24.8067C12.2693 24.5467 12.2666 24.124 12.5253 23.8627C18.4666 17.8733 18.4666 8.12535 12.5253 2.13602C12.2666 1.87469 12.2693 1.45202 12.5293 1.19202C12.7906 0.932021 13.2119 0.938687 13.4733 1.19602C19.9266 7.70535 19.9266 18.2933 13.4733 24.8027C13.3426 24.9333 13.1719 25 12.9999 25Z",
  fill: "#9E9E9E",
  stroke: "#9E9E9E",
  strokeWidth: 0.3
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M23.8398 10.3333H2.15983C1.79183 10.3333 1.49316 10.0347 1.49316 9.66667C1.49316 9.29867 1.79183 9 2.15983 9H23.8398C24.2078 9 24.5065 9.29867 24.5065 9.66667C24.5065 10.0347 24.2078 10.3333 23.8398 10.3333Z",
  fill: "#9E9E9E",
  stroke: "#9E9E9E",
  strokeWidth: 0.3
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M23.8398 17.0003H2.15983C1.79183 17.0003 1.49316 16.7017 1.49316 16.3337C1.49316 15.9657 1.79183 15.667 2.15983 15.667H23.8398C24.2078 15.667 24.5065 15.9657 24.5065 16.3337C24.5065 16.7017 24.2078 17.0003 23.8398 17.0003Z",
  fill: "#9E9E9E",
  stroke: "#9E9E9E",
  strokeWidth: 0.3
});

var SvgExternalLinks = function SvgExternalLinks(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgExternalLinks, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/externalLinks.998ad872.svg";
export { ForwardRef as ReactComponent };